<template>
  <div class="tokyo_tm_home">
    <div class="home_content">
      <div class="avatar">
        <div
          class="image avatar_img"
          :style="{ backgroundImage: 'url(' + src1 + ')' }"
        ></div>
      </div>
      <!-- End .avatar -->
      <div class="details">
        <h3 class="name">Juan Carlos Pineda</h3>
        <p class="job">
          Junior Web Developer / Creative Designer based in Barcelona 
          I am always willing to provide a variety of visual and graphic 
          solutions for your business, product, project or service.
        </p>

        <Social />
      </div>
      <!-- End .details -->
    </div>
  </div>
</template>

<script>
  import Social from "./Social";
  export default {
    components: {
      Social,
    },
    data() {
      return {
        src1: require("../assets/img/slider/2.jpg"),
      };
    },
  };
</script>

<style lang="scss"></style>
